module.exports = __webpack_public_path__ + "static/media/foodPattern.61386523.svg";